import { render, staticRenderFns } from "./formPickUp.vue?vue&type=template&id=79329aa2&"
import script from "./formPickUp.vue?vue&type=script&lang=js&"
export * from "./formPickUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/formPickUp/formPickUp.vue"
export default component.exports